import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import FileDetailModal from "components/FileDetailModal";
import dateFormatter from "modules/utils/DateFormatter";
import googleActions from "modules/google/actions";
import facebookActions from "modules/facebook/actions";

const TargetCard = ({ type, data, leadFormId, leadType }) => {
  const rmpToken = sessionStorage.getItem("rmp_token");
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [modalFileDetailDisplay, setModalFileDetailDisplay] = useState("hide");
  const [sheetsUpdate, setSheetsUpdate] = useState({});

  const getAllLeadFormSettings = async (tab) => {
    if (leadType == "facebook") {
      await dispatch(
        facebookActions.getAllLeadFormSettings({
          token: rmpToken,
          appReserve: tab,
        }),
      );
    } else if (leadType == "google") {
      await dispatch(
        googleActions.getAllGoogleLeadFormSettings({
          token: rmpToken,
          appReserve: tab,
        }),
      );
    }
  };

  /**
   * card is google sheets/rcrm card in all connection page
   * modal is google sheets/rcrm card in setting modal
   */
  const handleShowDetailFile = async () => {
    setModalFileDetailDisplay("show");

    if (data.position == "card") {
      getGoogleAccount();
    } else if (data.position == "modal") {
      await dispatch(
        facebookActions.updateSheetsModifiedData({
          updatedDate: data.updatedDate,
          updatedByImage: data.updatedByImage,
          updatedBy: data.updatedBy,
        }),
      );
    }
  };

  const getGoogleAccount = async () => {
    await dispatch(facebookActions.setFileInfoError(null)); // clear error message ใช้สำหรับ google และ facebook
    await dispatch(facebookActions.updateSheetsModifiedData({}));
    const googleAccountData = await dispatch(
      googleActions.getGoogleAccount({
        token: rmpToken,
        googleAccount: data.googleAccount,
      }),
    );

    if (googleAccountData.result === 0 && googleAccountData.data != null) {
      if (data.googleStatus !== "error") {
        const sheets = await dispatch(
          googleActions.getGoogleSheetsList({
            token: rmpToken,
            refreshToken: googleAccountData.data.refresh_token,
            googleAccount: googleAccountData.data.google_account,
            spreadsheetUrl: data.fileLink,
          }),
        );

        if (sheets.result === 0 && sheets.data != null) {
          setSheetsUpdate({
            updatedDate: sheets.data.modifiedTime,
            updatedByImage: sheets.data.lastModifyingUser.photoLink,
            updatedBy: sheets.data.lastModifyingUser.displayName,
          });
          await dispatch(
            facebookActions.updateSheetsModifiedData({
              updatedDate: sheets.data.modifiedTime,
              updatedByImage: sheets.data.lastModifyingUser.photoLink,
              updatedBy: sheets.data.lastModifyingUser.displayName,
            }),
          );
          await dispatch(facebookActions.setFileInfoError(null)); // ใช้สำหรับ google และ facebook
        } else if (sheets.result === 1) {
          await updateStatusFileInfoError();
        }
      } else {
        await dispatch(facebookActions.setFileInfoError("gsheet_not_found")); // ใช้สำหรับ google และ facebook
      }
    }
  };

  const updateStatusFileInfoError = async () => {
    if (leadType === "facebook") {
      // facebook connection
      await dispatch(
        facebookActions.updateFBLeadFormSettingErrorStatus({
          token: rmpToken,
          facebookLeadSettingId: leadFormId,
          connectedApp: "googleSheets",
          errorMessage: "gsheet_not_found",
        }),
      );
      await dispatch(facebookActions.setFileInfoError("gsheet_not_found")); // ใช้สำหรับ google และ facebook
      await getAllLeadFormSettings("googleSheets");
    } else if (leadType === "google") {
      // google connection
      await dispatch(
        googleActions.updateGGLeadFormSettingErrorStatus({
          token: rmpToken,
          googleLeadSettingId: leadFormId,
          connectedApp: "googleSheets",
          errorMessage: "gsheet_not_found",
        }),
      );
      await dispatch(facebookActions.setFileInfoError("gsheet_not_found")); // ใช้สำหรับ google และ facebook
      await getAllLeadFormSettings("googleSheets");
    }
  };

  return (
    <>
      <TargetCardContainer position={data.position}>
        <a href={data.fileLink} target="_blank" rel="noopener noreferrer">
          <LogoImage src={type === "googleSheets" ? "/images/sheets.png" : "/images/r-crm-icon.png"} />
        </a>
        <CardContent>
          <CardName>{data.name}</CardName>
          {type === "googleSheets" && (
            <FileDetail onClick={() => handleShowDetailFile()}>{t("__fbleads_google_sheets_file_detail")}</FileDetail>
          )}
          {type === "rcrm" && <GateDetail>{data.gateId}</GateDetail>}
        </CardContent>
      </TargetCardContainer>
      {type === "googleSheets" && (
        <FileDetailModal
          show={modalFileDetailDisplay}
          setShow={setModalFileDetailDisplay}
          fileName={data.name}
          folderType={data.folderType}
          folderName={data.folderName}
          folderCount={data.folderCount}
          folderUrl={data.folderUrl}
          updatedDate={
            data.position == "card"
              ? dateFormatter.formatDatetimeFull(sheetsUpdate.updatedDate, sessionStorage.getItem("lang"))
              : dateFormatter.formatDatetimeFull(data.updatedDate, sessionStorage.getItem("lang"))
          }
          updatedByImage={data.position == "card" ? sheetsUpdate.updatedByImage : data.updatedByImage}
          updatedBy={data.position == "card" ? sheetsUpdate.updatedBy : data.updatedBy}
        />
      )}
    </>
  );
};

export default TargetCard;

const TargetCardContainer = styled.div.attrs((props) => ({
  margin: props.position === "modal" ? "25px 0 0 0" : "0px",
}))`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #f9f9f9;
  border-radius: 6px;
  padding: 10px;
  margin: ${(props) => props.margin};
  width: 100%;

  a {
    display: flex;
  }
`;

const LogoImage = styled.img`
  width: 40px;
  height: 40px;
  position: relative;
  top: 5px;
`;

const CardContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  line-height: 1.5rem;
  margin-left: 10px;
`;

const CardName = styled.div`
  font-size: 14px;
  white-space: wrap;
  text-decoration: none;
  margin-right: 10px;
  word-break: break-word;
`;

const FileDetail = styled.div`
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
  color: #aaa;
`;

const GateDetail = styled.div`
  font-size: 12px;
  color: #aaa;
`;
